import { z } from 'zod';
export const AssistantResponseSchema = z
    .object({
    id: z.string(),
    projectId: z.string(),
    moderatorId: z.string(),
    vapiAssistantId: z.string(),
    createdAt: z.string().datetime(),
})
    .strict();
export const AssistantsResponseSchema = z
    .object({
    assistants: z.array(AssistantResponseSchema),
})
    .strict();
export const SaveAssistantsRequestSchema = z
    .object({
    previewId: z.string().optional(),
    voiceProvider: z.enum(['vapi', 'elevenlabs']).optional(),
    cleanupRequested: z.boolean().optional(),
    assistants: z.array(z
        .object({
        moderatorId: z.string(),
        vapiAssistantId: z.string(),
    })
        .strict()),
})
    .strict();
export const DeleteAssistantsResponseSchema = z
    .object({
    deletedVapiAssistantIds: z.array(z.string()),
})
    .strict();
export const PreviewAssistantCleanupClaimSchema = z.object({
    id: z.string().uuid(),
    projectId: z.string().uuid(),
    vapiAssistantId: z.string().min(1),
    voiceProvider: z.enum(['vapi', 'elevenlabs']),
    cleanupRequestedAt: z.string().datetime(),
    leaseToken: z.string().uuid(),
});
export const PreviewAssistantCleanupClaimsResponseSchema = z.object({
    assistants: z.array(PreviewAssistantCleanupClaimSchema),
});
export const PreviewAssistantCleanupClaimRequestSchema = z.object({
    dueBefore: z.string().datetime(),
    leaseUntil: z.string().datetime(),
    limit: z.number().int().positive().max(100),
});
export const PreviewAssistantCleanupLeaseRequestSchema = z.object({
    leaseToken: z.string().uuid(),
});
//# sourceMappingURL=Assistants.js.map